<template>
  <div class="animated fadeIn">
    <filters :scope="filtersScope">
    </filters>

    <div style="overflow:hidden; width:100%; z-index: -10;">
      <div id="swipe" v-hammer:pan="onSwipe" style="display:flex;flex-wrap: nowrap; width: 100%; z-index: -10;"
           :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}">

        <div class="statistic-wrap" >
          <div class="card statistic-table">
              <div class="card-header">
                {{`${$t('pages.cross_sell')}`}}
              </div>
              <div class="card-block">
                <table class="table">
                  <thead>
                  <tr>
                    <th style="background-color: #e0e0e0;">Операторы</th>
                    <th @click="isPopup(col)" colspan="2" :style="{background: col.isMain ? '#ffd96a' : col.color}" style="white-space: nowrap; cursor: pointer;" v-for="col in headColumns">{{col.label}}</th>
                    <th style="background-color: #81c784;">Одобрено</th>
                    <th style="background-color: #fff9c4;">Общее кол-во</th>
                    <th style="background-color: #90caf9;">Средний чек</th>
                    <th style="background-color: #8fbc8f;">Апрув от валида</th>
                  </tr>
                  </thead>

                  <tbody>
                  <template v-for="rowItems in rows">
                    <tr v-for="(row, operator) in rowItems">
                      <td style="background-color: #e0e0e0;">{{findOperator(operator)}}</td>
                      <template v-for="item in row">
                        <td style="background-color: #fff9c4;">{{item.quantity}}</td>
                        <td style="background-color: #90caf9;">{{item.quantity > 0 ? '$ ' + (item.total_bill / item.quantity).toFixed(2) : 0}}</td>
                      </template>
                      <td style="background-color: #81c784;">{{row.Approved}}</td>
                      <td style="background-color: #fff9c4;">{{row.Quantity}}</td>
                      <td style="background-color: #90caf9;">{{row.AverageBill}}</td>
                      <td style="background-color: #8fbc8f;">{{approvedFromValid(row.Approved, row.Total, row.Spam)}}</td>
                    </tr>
                  </template>
                  </tbody>
                  <tfoot>
                  <tr>
                    <th style="background-color: #e0e0e0;">Итого:</th>
                    <template v-for="row in footColumns">
                      <th style="background-color: #fff9c4;" >{{row.footQuantity}}</th>
                      <th style="background-color: #90caf9;">{{row.footQuantity > 0 ? '$ ' + (row.footTotal / row.footQuantity).toFixed(2) : 0}}</th>
                    </template>
                    <th style="background-color: #81c784;">{{footColumns.footSumApproved}}</th>
                    <th style="background-color: #fff9c4;">{{footColumns.footSumQuantity}}</th>
                    <th style="background-color: #90caf9;">{{footColumns.footSumAverageBill}}</th>
                    <th style="background-color: #8fbc8f;">{{approvedFromValid(footColumns.footSumApproved, footColumns.footSumTotal, footColumns.footSumSpam)}}</th>
                  </tr>
                  </tfoot>
                </table>
              </div>
          </div>
        </div>
      </div>
    </div>



    <modal v-model="crossSellModal" effect="fade/zoom">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">{{ titleModal }}</h4>
      </div>
      <div>
        <div class="search_offers">
            <input type="text" v-model="search" placeholder="Поиск оффера...">
        </div>
        <div class="offers">
          <div class="offers_items"
               :key="item.id"
               v-for="item in this.filterRowsModal"
               @click="selectedOffers(item)"
               :class="getClasses(item)">
            <div>{{item.offerName}}</div>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button class="btn btn-success" @click="crossSellApply()"> {{ $t('verbs.save') }}</button>
        <button class="btn btn-danger" @click="crossSellModal = false"> {{ $t('verbs.close') }}</button>
      </div>
    </modal>

  </div>
</template>

<script>
import Filters from '../../../components/Filters'
import API from '../../../api/API'
import {map, orderBy, uniqBy, sum, every, join, uniq} from 'lodash'
import StatisticTable from '../../../components/StatisticTable'
import Helper from '../../../api/Helper'
import Storage from '../../../api/Storage'
import { modal } from 'vue-strap'

export default {
  components: {
    StatisticTable,
    Filters,
    modal
  },
  data () {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        operatorFilter: true
      },
      headColumns: [],
      rows: [],
      footColumns: [],
      crossSellModal: false,
      titleModal: '',
      rowsModal: [],
      changeOffers: [],
      search: '',
      getOffersSell: [],
      x: 0,
      operators: []
    }
  },
  mounted () {
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  computed: {
    filterRowsModal () {
      return this.rowsModal.filter(item => item.offerName.indexOf(this.search) !== -1)
    }
  },
  methods: {
    onSwipe (e) {
      const offset = document.getElementById('swipe').offsetWidth
      const scroll = document.getElementById('swipe').scrollWidth
      const width = scroll - offset
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10
        } else {
          this.x -= e.distance / 10
        }
        if (this.x > 0) {
          this.x = 0
        }
        if (Math.abs(this.x) > width) {
          this.x = -width
        }
      }
    },
    filterArr (arr) {
      const newArr = arr.filter((item, index) => {
        return arr.indexOf(item) === index
      })
      return newArr
    },
    findOperator (id) {
      let operator = Helper.getOperatorLogin(this.operators, id)
      return operator
    },
    approvedFromValid (approved, total, spam) {
      return `${((approved / (total - spam)) * 100).toFixed(1)}%`
    },
    countById (array) {
      let resultSplit = array.map(item => {
        if (item) {
          return item.split(',')
        } else {
          return []
        }
      })
      let resultSplitConcat = []
      for (let i = 0; i < resultSplit.length; i++) {
        resultSplitConcat.push(...resultSplit[i])
      }
      uniq(resultSplitConcat)
      return uniq(resultSplitConcat)
    },
    async calculateRows () {
      this.headColumns = []
      this.rows = []
      this.footColumns = []
      await API.getOperators(Helper.getCountryList()).then(operators => {
        this.operators = operators.body
      })
      await API.getCrossSell().then(response => {
        API.getGoodsMain().then(goods => {
          const goodsAll = goods.body
          let data = []
          let rowItemsGoods = []
          let rowItemsGoodsId = []

          const goodsId = []
          const operatorId = []

          const goodsIsMain = goodsAll.filter((item) => { return item.is_main_good })
          let goodsIsMainId = goodsIsMain.map(item => { return item.id })

          map(response.body, arr => {
            arr.forEach(item => {
              goodsId.push(item.good_id)
              operatorId.push(item.operator_id)
            })
            data.push(arr)
          })
          const filterGoodsId = this.filterArr(goodsId)
          const filterOperatorId = this.filterArr(operatorId)
          let totalSumApproved = []
          let totalSumAllTotal = []
          let totalSumSpam = []
          map(data, arr => {
            for (let i = 0; i < filterGoodsId.length; i++) {
              arr.push({
                operator_id: arr[i].operator_id,
                good_id: filterGoodsId[i],
                total_bill: 0,
                quantity: 0
              })
            }
            let uniqGoods = orderBy(uniqBy(arr, 'good_id'), 'good_id', 'asc')
            let row = {}
            let rowItems = []
            let quantitySum = 0
            let totalSum = 0
            let arrApproved = []
            let arrApprovedId = []
            let arrTotal = []
            let arrTotalId = []
            let arrSpam = []
            let arrSpamId = []
            for (let j = 0; j < filterOperatorId.length; j++) {
              for (let i = 0; i < uniqGoods.length; i++) {
                if (filterOperatorId[j] === uniqGoods[i].operator_id) {
                  quantitySum += uniqGoods[i].quantity ? uniqGoods[i].quantity : 0
                  totalSum += uniqGoods[i].total_bill ? uniqGoods[i].total_bill : 0
                  arrApproved = uniqGoods[i].approved
                  arrApprovedId.push(arrApproved)
                  arrTotal = uniqGoods[i].total
                  arrTotalId.push(arrTotal)
                  arrSpam = uniqGoods[i].spam
                  arrSpamId.push(arrSpam)
                  if (goodsIsMainId.includes(uniqGoods[i].good_id)) {
                    uniqGoods[i].is_main = true
                    rowItems.unshift(uniqGoods[i])
                  } else {
                    rowItems.push(uniqGoods[i])
                  }
                  let countApproved = this.countById(arrApprovedId)
                  let countTotal = this.countById(arrTotalId)
                  let countSpam = this.countById(arrSpamId)
                  rowItems.Quantity = quantitySum
                  rowItems.AverageBill = quantitySum > 0 ? '$ ' + (totalSum / quantitySum).toFixed(2) : 0
                  rowItems.Approved = countApproved.length
                  rowItems.Total = countTotal.length
                  rowItems.Spam = countSpam.length
                  row = { [filterOperatorId[j]]: rowItems }
                }
              }
            }
            this.rows.push(row)
            if (typeof row === 'object') {
              this.headColumns = []
              map(row, arr => {
                map(arr, item => {
                  this.headColumns.push(
                      {label: Helper.getGoodNameById(goods.body, item.good_id), isMain: item.is_main, color: '#fff9c4', id: item.good_id}
                  )
                })
              })
            }
            map(row[0], item => {
              this.headColumns.push(
                  {label: Helper.getGoodNameById(goods.body, item.good_id), isMain: item.is_main, color: '#fff9c4', id: item.good_id}
              )
            })
            map(row, arrs => {
              totalSumApproved.push(arrs.Approved)
              totalSumAllTotal.push(arrs.Total)
              totalSumSpam.push(arrs.Spam)
              map(arrs, item => {
                rowItemsGoods.push(item)
                rowItemsGoodsId.push(item.good_id)
              })
            })
          })
          let newIdGoods = this.filterArr(rowItemsGoodsId)
          let totalSumNQuantity = []
          let totalSumTotal = []
          for (let i = 0; i < newIdGoods.length; i++) {
            let row = []
            for (let j = 0; j < rowItemsGoods.length; j++) {
              if (newIdGoods[i] === rowItemsGoods[j].good_id) {
                row.push(rowItemsGoods[j])
              }
            }
            totalSumNQuantity.push(row.map(x => x.quantity).reduce((a, b) => a + b))
            totalSumTotal.push(row.map(x => x.total_bill ? x.total_bill : 0).reduce((a, b) => a + b))
            this.footColumns.push({
              good_id: newIdGoods[i],
              footQuantity: row.map(x => x.quantity).reduce((a, b) => a + b),
              footTotal: row.map(x => x.total_bill).reduce((a, b) => a + b)
            })
          }
          this.footColumns.footSumQuantity = sum(totalSumNQuantity)
          this.footColumns.footSumAverageBill = '$ ' + (sum(totalSumTotal) / sum(totalSumNQuantity)).toFixed(2)
          this.footColumns.footSumApproved = sum(totalSumApproved)
          this.footColumns.footSumTotal = sum(totalSumAllTotal)
          this.footColumns.footSumSpam = sum(totalSumSpam)
        })
      })
    },
    getClasses (item) {
      let classes = []
      if (item.productIsOn) {
        classes.push('isActive')
      } else {
        classes.push('noActive')
      }
      return classes
    },
    isPopup (product) {
      this.rowsModal = []
      this.titleModal = product.label
      this.getOffersSell = []
      API.getOffers(Helper.getCountryList()).then(response => {
        map(response.body, item => {
          this.rowsModal.push({
            offerName: item.name,
            offerId: item.id,
            countryId: item.country_id,
            productId: product.id,
            productIsOn: item.main_good_id !== null && product.id === item.main_good_id
          })
        })
      })
      this.crossSellModal = true
    },
    selectedOffers (item) {
      if (this.getOffersSell.includes(item)) {
        every(this.getOffersSell, {productIsOn: item.productIsOn = !item.productIsOn})
      } else {
        item.productIsOn = !item.productIsOn
        this.getOffersSell.push(item)
      }
    },
    crossSellApply () {
      let country = []
      let offersOn = []
      let offersOff = []
      map(this.getOffersSell, item => {
        country.push(item.countryId)
        if (item.productIsOn) {
          offersOn.push({
            offer_id: item.offerId,
            good_id: item.productId
          })
        } else {
          offersOff.push({
            offer_id: item.offerId,
            good_id: item.productId
          })
        }
      })
      country = this.filterArr(country).join(',')
      if (offersOn.length) {
        API.postChooseMainGood(country, offersOn)
      }
      if (offersOff.length) {
        API.postCancelMainGood(country, offersOff)
      }
      this.calculateRows()
      this.crossSellModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
.msl-multi-select {
  width: 100%;
  height: 400px;
}
.search_offers {
  input {
    width: 100%;
    padding: 10px;
    outline: none;
  }
}
.offers {
  border: 1px solid;
  margin-top: 10px;
  height: 360px;
  overflow: auto;
  padding: 10px;
  &_items {
    display: flex;
    cursor: pointer;
    background-color: #e0e0e0;
    padding: 10px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
    &.isActive {
      background-color: #ffd96a;
    }
  }
}

</style>



// WEBPACK FOOTER //
// CrossSell.vue?201662e6